<template>
  <layout>
    <h4>Coming soon mode</h4>
    <form @submit.prevent="submit">
      <fields
        :fields="fields.all()"
        :model="model"
        :errors="errors" />
      <div class="form-group">
        <b-button
          type="submit"
          variant="primary">
          Save
        </b-button>
      </div>
    </form>
  </layout>
</template>

<script>
import { FormMixin } from 'stylemix-base';
import Layout from '../layouts/Default.vue';

const base = 'coming-soon';

export default {
  name: 'ComingSoonForm',

  components: {
    Layout,
  },

  mixins: [FormMixin],

  data: () => ({
    model: {},
  }),

  created() {
    this.$http.get(base)
      .then((result) => {
        this.model = result.data.data;
        this.setFields(result.data.fields);
      });
  },

  methods: {
    submit() {
      this.$http.post(base, this.model)
        .then(() => {
          this.$toast.success('Settings were saved successfully');
        })
        .catch((response) => {
          if (response.status === 422) {
            this.setValidationErrors(response.data.errors);
            this.$toast.error(response.data.message);
          }
        });
    },
  },

};
</script>
